// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tRkn","content":"styles_content__1oJ0y"};